var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFacebook = function SvgIconFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30.001,
    viewBox: "0 0 30 30.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2065",
    "data-name": "Grupo 2065",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3984",
    "data-name": "Caminho 3984",
    d: "M318.19,71.883a15,15,0,1,0-15-15,15,15,0,0,0,15,15",
    transform: "translate(-303.19 -41.882)",
    fill: "#3569b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3985",
    "data-name": "Caminho 3985",
    d: "M332.942,66.633h1.7V65.069a3.99,3.99,0,0,1,.547-2.411,3.087,3.087,0,0,1,2.638-1.172,11.246,11.246,0,0,1,3.048.29l-.426,2.384a6.035,6.035,0,0,0-1.369-.194c-.66,0-1.253.224-1.253.85v1.817h2.71l-.189,2.328h-2.521v8.089h-3.185V68.961h-1.7Z",
    transform: "translate(-321.908 -54.267)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-facebook.602157a3.svg";
export { ForwardRef as ReactComponent };